import { FC, PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { Alert, Stack } from "@mui/material";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  max-width: 800px;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  color: #171a1fff;
  margin: 0;
`;

const Icon = styled.div`
  width: 36px;
  height: 36px;
  background: #1e64ddff;
  color: #fff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export interface OnboardingFormProps {
  title?: string | JSX.Element | JSX.Element[];
  subtitle?: string | JSX.Element | JSX.Element[];
  icon?: JSX.Element;
}

const OnboardingForm: FC<PropsWithChildren<OnboardingFormProps>> = ({
  title,
  icon,
  subtitle,
  children,
}) => {
  return (
    <FormContainer>
      {(title || subtitle) && (
        <Stack width="100%" gap="16px" marginBottom="36px">
          {subtitle && (
            <Alert variant="standard" severity="info" color="info">
              {subtitle}
            </Alert>
          )}

          {title && (
            <Stack
              flexDirection="row"
              gap="16px"
              marginTop="16px"
              alignItems="center"
            >
              {icon && <Icon>{icon}</Icon>}
              <Title>{title}</Title>
            </Stack>
          )}
        </Stack>
      )}

      {children}
    </FormContainer>
  );
};

export default OnboardingForm;
